module.exports = __webpack_public_path__ + "img/compare-blank.d75d3658.svg";